import { Button, Card, Col, Input, Row, Spin, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useClient } from "../../../Context/ClientContext";
import { ColumnsType } from "antd/es/table";
import {
  DeleteOutlined,
  EditOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { notificationContext } from "../../../Common/Routing/PageRoute";
import { ConfirmationModal } from "../../../Common/ConfirmationModal";
import { useTheme } from "../../../Context/ThemeContext";
import AssetCategoriesService, {
  AssetCategories_Type,
  AssetCategoriesTypesList,
  ICategoryTable,
} from "../../../Services/AssetCategoriesService";
import AddAssetCategoryModal from "./AddAssetCategoryModal";
import { tablePageSizeOptions } from "../../../Common/ThemeSetting";

const AssetCategories = () => {
  const { currentClient } = useClient();
  const { themeData } = useTheme();
  const { openNotification } = React.useContext(notificationContext);
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);
  const [categoriesDataList, setCategoriesDataList] = React.useState<
    ICategoryTable[]
  >([]);
  // const [addAssCategory, setAddAssCategory] = useState<IFACategoryList>({
  //   categoryName: "",
  // });

  const [pageSize, setPageSize] = React.useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [page, setPage] = React.useState(1);
  const [totalRecords, setTotalRecords] = React.useState<number>(0);
  const [id, setId] = React.useState<any>({ id: "", name: "" });
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [search, setSearch] = React.useState<string>("");

  React.useEffect(() => {
    getCategoriesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(page - 1) * pageSize, pageSize, refresh, search]);

  const getCategoriesList = async () => {
    setLoading(true);
    let res = await AssetCategoriesService.getCategoriesList(
      currentClient?.id,
      (page - 1) * pageSize,
      pageSize,
      search
    );
    if (res?.totalRecords! > 0) {
      setCategoriesDataList(
        res?.items?.map((d) => ({
          categoryName: d?.categoryName,
          assetCategoryType: d?.assetCategoryType,
          parentCategoryId: d?.parentCategoryId,
          parentCategoryName: d?.parentCategoryName,
          id: d?.id,
        })) || []
      );
      setLoading(false);
      setTotalRecords(res?.totalRecords as number);
    } else {
      setLoading(false);
    }
  };

  const deleteCategoryData = async () => {
    let res = await AssetCategoriesService?.deleteCategoryDatabyId(
      currentClient?.id,
      id?.id
    );
    if (res?.status) {
      setRefresh((prev) => !prev);
      openNotification("success", "Asset category deleted successfully.");
      setConfirmation(false);
    } else {
      openNotification("error", res?.message);
      setConfirmation(false);
    }
  };

  // To update the asset locations list with amended new asset location
  // useEffect(() => {
  //   if (addAssCategory.id) {
  //     setCategoriesDataList((prev) =>
  //       updateListWithNewValue(prev, addAssCategory, true).sort((a, b) =>
  //         a.categoryName.localeCompare(b.categoryName)
  //       )
  //     );
  //   }
  // }, [addAssCategory]);

  const columns: ColumnsType<ICategoryTable> = [
    {
      title: "S.No.",
      width: "10%",
      render: (val, _, index: number) => index + 1,
    },
    { title: "Asset category's name", dataIndex: "categoryName" },
    {
      title: "Asset category's type",
      dataIndex: "assetCategoryType",
      render: (val: AssetCategories_Type) =>
        AssetCategoriesTypesList.find((cat) => cat.value === val)?.label,
    },
    { title: "Parent category's name", dataIndex: "parentCategoryName" },
    {
      title: "Action",
      dataIndex: "",
      render: (_, record) => (
        <>
          <Row gutter={10}>
            <Col>
              <Tooltip title="Edit">
                <EditOutlined
                  onClick={() => {
                    setId({ id: record?.id, name: record?.categoryName });
                    setIsModelOpen(true);
                  }}
                />
              </Tooltip>
            </Col>
            <Col>
              <Tooltip title="Delete" color="red">
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={() => {
                    setId({ id: record?.id, name: record?.categoryName });
                    setConfirmation(true);
                  }}
                />
              </Tooltip>
            </Col>
          </Row>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <Card
          size="small"
          className="TableCard"
          style={{
            marginTop: 35,
            boxShadow: "0px 0px 10px 0px #96A1C84D",
          }}
        >
          <div style={{ padding: "0px 0px 3px 0px" }}>
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: 20 }} />}
              spinning={loading}
            >
              <Row justify={"space-between"}>
                <Col>
                  <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    onClick={() => {
                      setIsModelOpen(true);
                      setId("");
                    }}
                  >
                    Asset Category
                  </Button>
                </Col>
                <Col>
                  <Input
                    placeholder="Search..."
                    allowClear
                    onClear={() => setSearch("")}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        setSearch(e.currentTarget.value);
                      } else {
                        return e;
                      }
                    }}
                  />
                </Col>
              </Row>
              <div style={{ marginTop: "4px" }}>
                <Table
                  className={`Tabel-style table-${
                    themeData?.componentSize ?? "middle"
                  }`}
                  columns={columns}
                  dataSource={categoriesDataList}
                  pagination={{
                    total: totalRecords,
                    current: page,
                    pageSize: pageSize,
                    showSizeChanger: true,
                    onChange: (page: number, pageSize: number) => {
                      setPage(page);
                      setPageSize(pageSize);
                    },
                    pageSizeOptions: tablePageSizeOptions,
                  }}
                  scroll={
                    pageSize > 15
                      ? { x: 1500, y: window.innerHeight - 300 }
                      : undefined
                  }
                />
              </div>
            </Spin>
          </div>
        </Card>
      </div>

      {isModelOpen && (
        <AddAssetCategoryModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
          id={id?.id}
          setRefresh={setRefresh}
          // setAddAssCategory={setAddAssCategory}
        />
      )}

      {confirmation && (
        <ConfirmationModal
          open={confirmation}
          onNo={() => setConfirmation(false)}
          onYes={() => {
            deleteCategoryData();
          }}
          text={`Are you sure you want to delete "${id?.name}"? `}
        />
      )}
    </>
  );
};

export default AssetCategories;
